export default __webpack_public_path__ + "static/media/logo_ss360.0693c658.jpeg";